import styled, { css } from "react-emotion";

export const Container = styled("div")`
  height: 100%;
  width: ${(props) => props.width};
  text-align: center;
`;

export const formContainer = css`
  width: 50%;
`;

export const greyText = css`
  color: #bbb;
  margin-bottom: 10px;
`;

export const guestPromptContainer = css`
  background-color: #fff;
  border-color: #ddd;
  box-shadow: 0 1px 4px rgba(221, 221, 221, 0.6);

  @media (min-width: 968px) {
    display: block;
  }

  border: 1px solid #ebebeb;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(95, 95, 95, 0.14);
  /* display: none; */
  margin: 0rem 0 1.5rem;
  padding: 20px;
`;

export const inputStyle = css`
  border: none;
  border-bottom: 1px solid #1f3747;
  background: none;
  outline: none;
  color: black;
  padding: 5px;
  box-shadow: none;
  font-size: 1em;
  transition: opacity 0.2s;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;

  &:hover,
  :focus {
    opacity: 1;
    transition: opacity 0.4s;
  }

  &::placeholder {
    color: #1f3747;
    font-size: 1em;
    opacity: 0.8;
  }
`;

export const inputLabel = css`
  color: #1f3747;
  font-size: 22px;
  text-transform: capitalize;
  align-self: flex-start;
`;

export const buildButton = css`
  height: 42px;
  width: 206px;
  background: #78d2b1;
  padding: 10px;
  border-radius: 5px;
  color: white;
  text-decoration: none;
  text-align: center;
`;

export const flexRow = css`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 20px;
`;

export const flexColumn = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const message = css`
  margin: 1em 0 1em 0;
`;

export const unStyledButton = css`
  color: #666666;
  text-decoration: none;

  &:hover {
    color: #000000;
  }
`;

export const WebButton = styled("button")`
  padding: 10px;
  width: 190px;
  border-radius: 4px;
  color: white;
  background: ${(props) => props.background};
  font-weight: bold;
  border: none;
  box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  cursor: pointer;
`;
